module.exports = __webpack_public_path__ + "img/star.ba9b8f66.png";